import { constructIds } from "../../../config/common";
const shortUUid = require("short-uuid");


export const getNetworks = (state) => {
    return state.constructs.networks;
}


export const networkForDelegate = ( payload ) => {
    const { editedDelegate, constructs } = payload

    // console.log({ editedDelegate, constructs })
    let networkExists = true;

    let network = constructs.networks.find(element => {
        if((element.name.toLowerCase() === editedDelegate.attributes.network.toLowerCase())) {
                return element
        }
    })

    if(network && network.attributes.delegate_type) delete network.attributes.delegate_type;

    if(!network){
        network = {
            id: shortUUid.generate(),
			name: editedDelegate.attributes.network,
			attributes: {
				dhcp: "yes",
				// delegate_type: editedDelegate.attributes.type
			},
			type: constructIds.find(item => item.type === "network").id
		}
        networkExists = false;
    }

    return {
        networkExists,
        network,
    }

}